import React from "react";
import "./SeoToolsSection.css";

function SeoToolsSection() {
  const seoTools = [
    "Keyword suggestions for better ranking",
    "Meta title and description optimization",
    "Heading structure improvement",
    "Basic website SEO audit support",
    "Sitemap and indexing guidance",
    "Content visibility improvement tips",
  ];

  return (
    <section className="marketing-section seo-section">
      <div className="marketing-container seo-container">
        <div className="marketing-seo-layout seo-layout">
          <div className="marketing-seo-content seo-content">
            <span className="marketing-section-badge seo-badge">SEO Tools</span>

            <h3>Improve Search Visibility with Smarter SEO Tools</h3>

            <p>
              Optimize your pages, improve discoverability, and increase website
              traffic with practical SEO support built for business growth.
            </p>

            <div className="marketing-hero-actions seo-actions">
              <a
                href="#marketing-newsletter-form"
                className="marketing-primary-btn marketing-btn-link seo-primary-btn"
              >
                Start SEO Setup
              </a>

              <a
                href="#marketing-contact-form"
                className="marketing-secondary-btn marketing-btn-link seo-secondary-btn"
              >
                Talk to Sales
              </a>
            </div>

            <ul className="marketing-seo-list seo-list">
              {seoTools.map((tool, index) => (
                <li key={index}>{tool}</li>
              ))}
            </ul>
          </div>

          <div className="marketing-seo-card seo-card">
            <div className="seo-card-top">
              <div>
                <span>Live SEO Dashboard</span>
                <h4>SEO Performance Insights</h4>
              </div>
              <div className="seo-card-icon">📈</div>
            </div>

            <p>
              Get real-time improvement suggestions and track your website growth
              with easy-to-understand SEO analytics.
            </p>

            <div className="marketing-seo-mini-stats seo-mini-stats">
              <div className="marketing-seo-mini-box seo-mini-box">
                <h5>+45%</h5>
                <span>Traffic Growth</span>
              </div>

              <div className="marketing-seo-mini-box seo-mini-box">
                <h5>Top 10</h5>
                <span>Keyword Ranking</span>
              </div>

              <div className="marketing-seo-mini-box seo-mini-box">
                <h5>98%</h5>
                <span>Indexing Score</span>
              </div>

              <div className="marketing-seo-mini-box seo-mini-box">
                <h5>24/7</h5>
                <span>Monitoring</span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}

export default SeoToolsSection;